import { string } from "prop-types";
import { forwardRef, useCallback, useMemo } from "react";

import styled from "styled-components";

import { useMemberToobarContext } from "CrossFeatureComponents/MemberToolbar/MemberToolbarState";
import { contentKeys } from "CrossFeatureComponents/MemberToolbar/contentKeys";
import { useMemberToolbarStore } from "CrossFeatureComponents/MemberToolbar/memberToolbarStore";

import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrDeleteButton from "UI/FnrDeleteButton";
import FnrTappyShrink from "UI/FnrTappyShrink";

import { ButtonWrapper } from "../../shared";

const DisplayComponent = ({ color }) => {
  return (
    <FnrTappyShrink growOnHover>
      <SFnrContainedIcon color={color} icon="fa-chevron-left fas" />
    </FnrTappyShrink>
  );
};

DisplayComponent.propTypes = { color: string };

const BackButtonDisplay = forwardRef((props, ref) => {
  return (
    <ButtonWrapper
      aria-label="back-to-contact-menu"
      DisplayComponent={DisplayComponent}
      type="button"
      ref={ref}
      {...props}
      data-cy="MemberToolbar_BackToContactMenu"
    />
  );
});

const SFnrContainedIcon = styled(FnrContainedIcon)`
  width: 40px;
  transform: translateX(-1px);
`;

const BackButton = () => {
  const { message } = useMemberToobarContext();

  const confirmText = useMemo(() => {
    if (message) return "Going back will delete your message. Are you sure?";
    return "";
  }, [message]);

  const { setActiveContentKey } = useMemberToolbarStore();
  const { backButtonRef, setMessage } = useMemberToobarContext();

  const goBack = useCallback(() => {
    setActiveContentKey(contentKeys.contact);
    // delete message after animation completes since the input is kept in the DOM.
    setTimeout(() => setMessage(""), 300);
  }, [setActiveContentKey, setMessage]);

  return (
    <FnrDeleteButton
      Button={BackButtonDisplay}
      confirmText={confirmText}
      onClick={goBack}
      popoverWidth={300}
      ref={backButtonRef}
      confirmButtonText="I'm Sure"
      deleteIcon=""
      dataCancelClickAway="memberToolbarCancelKey"
    />
  );
};

export default BackButton;
